/* global Swiper */
(() => {
  const initBenefitsCarousel = () => {
    document.querySelectorAll('.benefits-carousel__swiper').forEach((swiperEl) => {
      const sectionId = swiperEl.id;
      const section = swiperEl.closest('.benefits-carousel');
      if (!section) return;

      const isCentered = section.classList.contains('benefits-carousel--centered');
      const prevButton = section.querySelector('.benefits-carousel__nav-btn--prev');
      const nextButton = section.querySelector('.benefits-carousel__nav-btn--next');

      const swiper = new Swiper(`#${CSS.escape(sectionId)}`, {
        slidesPerView: 'auto',
        spaceBetween: 0,
        grabCursor: true,
        freeMode: false,
        allowTouchMove: true,
        resizeObserver: false,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        on: {
          init: function () {
            updateArrowStates(this);
          },
          slideChange: function () {
            updateArrowStates(this);
          },
          resize: function () {
            setTimeout(() => updateArrowStates(this), 100);
          },
        },
      });

      function updateArrowStates(swiperInstance) {
        const shouldDisableArrows = () => {
          if (!isCentered || window.innerWidth < 640) return false;

          const slides = swiperInstance.slides;
          const container = swiperInstance.el;
          const containerWidth = container.clientWidth;

          let totalWidth = 0;
          slides.forEach((slide, index) => {
            const slideRect = slide.getBoundingClientRect();
            const slideStyle = window.getComputedStyle(slide);
            const slideWidth = slideRect.width;
            const slideMarginRight = (index < slides.length - 1) ? parseFloat(slideStyle.marginRight) || 0 : 0;
            totalWidth += slideWidth + slideMarginRight;
          });

          return totalWidth <= containerWidth;
        };

        if (prevButton) prevButton.disabled = swiperInstance.isBeginning || shouldDisableArrows();
        if (nextButton) nextButton.disabled = swiperInstance.isEnd || shouldDisableArrows();
      }
    });
  };

  const runInit = () => {
    if (typeof Swiper !== 'undefined') {
      initBenefitsCarousel();
    } else {
      document.addEventListener('swiper-loaded', initBenefitsCarousel, { once: true });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runInit);
  } else {
    runInit();
  }

  window.addEventListener('load', () => {
    setTimeout(() => {
      initBenefitsCarousel();
    }, 100);
  });
})();

